import { render } from "./ArticalSkeleton.vue?vue&type=template&id=56ed7530&scoped=true"
import script from "./ArticalSkeleton.vue?vue&type=script&lang=js"
export * from "./ArticalSkeleton.vue?vue&type=script&lang=js"

import "./ArticalSkeleton.vue?vue&type=style&index=0&id=56ed7530&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ed7530"]])

export default __exports__